<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>مشتریان فعال بدون پشتیبانی</h3>
        <hr />
      </template>
      <template slot="content">
        <BnpGrid Selectable :Sortable="true" :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" :key="keyTable">
          <template slot="action-slot" slot-scope="props">
            <a href="javascript:;" class="mr-2 badge" data-title="مشاهده جزئیات" @click="OnDetail(props.props)"
              ><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6
            ></a>
          </template>
          <template slot="customerName" slot-scope="props">
            <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
          </template>
          <template slot="result" slot-scope="props">
            <!-- <p>{{ props.props.result }}</p> -->
            <span v-if="props.props.result" style="font-size: 12px" :data-title="props.props.date + ' - ' + props.props.result">{{ props.props.result.length > 30 ? props.props.result.substring(0, 30) + (props.props.result.length > 30 ? '...' : '') : props.props.result }}</span>
          </template>
        </BnpGrid>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      propsColumn: [
        { name: 'customerCode', label: 'کد', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
        { name: 'lastDate', label: 'تاریخ آخرین قرارداد مشتری ', visibility: true },
        { name: 'result', label: ' آخرین تماس', visibility: true },
        // { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
      ],
      propsRows: [],
      keyTable: 0,
    }
  },
  created() {
    var Axios = { Method: 'GET', Action: 'Reports/ActiveNoSupport', ArryfildValue: null }
    this.$PostData(Axios).then((result) => {
      this.propsRows = result.data
      this.keyTable++
    })
  },
  methods: {
    OnViewCustomer(row) {
      this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', DataRow: row } })
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    Search() {
      this.$store.state.loading = true
      var DataAxiosSearch = {
        Action: 'TblCustomerCrm/SearchCustomer',
        Method: 'POST',
        ArryfildValue: {
          CustCode: this.CustCode,
          Allfields: this.Allfields,
          BazaryabiCode: this.BazaryabiCode,
          tblCombogrp11Shahr: this.tblCombogrp11Shahr,
          tblCombogrp10state: this.tblCombogrp10state,
        },
      }

      this.$PostData(DataAxiosSearch)
        .then((result) => {
          this.propsRows = result
          this.propsRows.sort((a, b) => {
            if (a.customerCode > b.customerCode) {
              return -1
            }
            if (a.customerCode < b.customerCode) {
              return 1
            }
            return 0
          })
          this.$store.state.CustomerManagerSearchResult = result
          this.$store.state.CustomerManagerCustCode = this.CustCode
          this.$store.state.CustomerManagerAllfields = this.Allfields
          this.$store.state.CustomerManagerBazaryabiCode = this.BazaryabiCode
          this.$store.state.CustomerManagertblCombogrp11Shahr = this.tblCombogrp11Shahr
          this.$store.state.CustomerManagertblCombogrp10state = this.tblCombogrp10state
          this.$mySweetDefaultTost('جستـــجو موفـق', '', 'success', 1000)
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    },
    GetResultState(data) {
      this.tblCombogrp10state = data.id
      this.rendergrid = false
      this.$nextTick(() => {
        this.rendergrid = true
      })
    },
    GetResultCity(data) {
      this.tblCombogrp11Shahr = data.id
    },
    OnDetail(data) {
      if (this.$store.state.Customer.Customer) {
        this.$store.state.Customer.Customer.Id = data.id
      }
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id } })
      this.$FindeCustomerById('DetailCustomer', data.id, false, null)
    },
    OnAndicator(data) {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 6 } })
      this.$FindeCustomerById('DetailCustomer', data.id, 6, null)
    },
    OnDemo(data) {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 7 } })
      this.$FindeCustomerById('DetailCustomer', data.id, 7, null)
    },
    OnTask(data) {
      // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 1 } })
      this.$FindeCustomerById('DetailCustomer', data.id, 1, null)
    },
    Enter(e) {
      if (e.which === 13) {
        this.Search()
      }
    },
  },
  components: { Card, BnpGrid },
}
</script>
